var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12019_27958)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.6667C12 13.9594 12.281 13.2811 12.781 12.781C13.2811 12.281 13.9594 12 14.6667 12H33.3333C34.0406 12 34.7189 12.281 35.219 12.781C35.719 13.2811 36 13.9594 36 14.6667V33.3333C36 34.0406 35.719 34.7189 35.219 35.219C34.7189 35.719 34.0406 36 33.3333 36H14.6667C13.9594 36 13.2811 35.719 12.781 35.219C12.281 34.7189 12 34.0406 12 33.3333V14.6667ZM26.5853 18.2067C26.1147 17.0293 24.428 17.096 24.0493 18.3053L21.7133 25.78L21.196 24.744C21.0841 24.5205 20.9123 24.3325 20.6996 24.2011C20.487 24.0697 20.242 24.0001 19.992 24H17.3333C16.9797 24 16.6406 24.1405 16.3905 24.3905C16.1405 24.6406 16 24.9797 16 25.3333C16 25.687 16.1405 26.0261 16.3905 26.2761C16.6406 26.5262 16.9797 26.6667 17.3333 26.6667H19.176L20.792 29.9C21.3347 30.984 22.9213 30.856 23.2827 29.7L25.488 22.6427L26.7587 25.82C26.9627 26.332 27.4587 26.6667 28.0093 26.6667H30.6667C31.0203 26.6667 31.3594 26.5262 31.6095 26.2761C31.8595 26.0261 32 25.687 32 25.3333C32 24.9797 31.8595 24.6406 31.6095 24.3905C31.3594 24.1405 31.0203 24 30.6667 24H28.9027L26.5853 18.2067Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12019_27958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/Performance.cb9b689c752fb59f5bf94cd20d54715c.svg";
export { ForwardRef as ReactComponent };